import {
  Redirect,
  Route,
  RouteProps,
  useLocation,
} from 'react-router-dom';

import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import useUserContext from '../../providers/User/UserProvider';
import NotificationRedirect from './NotificationRedirect';

const PrivateRoute = (props: RouteProps) => {
  const { error } = useMsalAuthentication(InteractionType.Redirect);
  const { isAuthenticated, isAdmin } = useUserContext();
  const location = useLocation();

  if (error) {
    return (
      <Redirect
        to={{
          pathname: '/login',
        }}
      />
    );
  }

  if (!isAuthenticated) {
    return <Redirect to={{ pathname: '/login' }} />;
  }

  if (location.pathname.startsWith('/admin') && !isAdmin) {
    return <NotificationRedirect />;
  }

  return <Route {...props} />;
};

export default PrivateRoute;
